export const izjava_prehrana= {
    templateId: 236,
    category: 4,
    templateTitle: 'Izjava radnika o ostvarenim paušalnim naknadama odnosno podmirenim troškovima prehrane kod bivšeg/bivših i/ili drugog/drugih poslodavaca',
    templateDescription: `<p>Radnik je obvezan poslodavcu koji namjerava isplatiti paušalnu naknadu za troškove prehrane odnosno podmiriti troškove prehrane, prije isplate podnijeti pisanu izjavu u kojoj navodi je li kod drugog/ih i/ili bivšeg/ih poslodavca ostvario isplatu nagrade za određeno razdoblje i u kojem iznosu. </p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    
    <p>Trošak prehrane radnika može od strane poslodavca biti neoporezivo podmiren kroz:</p>
    <li>novčane paušalne naknade za podmirivanje troškova prehrane radnika - do 6.000,00 godišnje ili,</li>
    <li>troškove prehrane radnika nastale za vrijeme radnog odnosa kod poslodavaca na temelju vjerodostojne dokumentacije, do 12.000,00 kuna godišnje, pod uvjetom da računi o obavljenim uslugama prehrane glase na poslodavca i da su podmireni bezgotovinskim putem.</li>
    <br>
    <p><strong>Važno je naglasiti da se paušalna naknada odnosno podmirenje troškova prehrane radnika  međusobno isključuju za isto porezno razdoblje, stoga ne mogu obje biti isplaćene u istom poreznom razdoblju.</p>
    <br>
    <p>Radnik:</p>
    <li>koji radi istovremeno kod dva ili više poslodavaca u poreznom razdoblju za koje se primici isplaćuju i/ili</li>
    <li>koji je tijekom poreznog razdoblja imao zasnovan radni odnos kod dva ili više poslodavaca, ali ne istovremeno,</li>
    <br>
    <p>je prije isplate paušalne naknade odnosno podmirenja troškova prehrane dužan poslodavcu koji namjerava isplatiti naknadu podnijeti pisanu izjavu u kojoj će navesti je li kod drugog i/ili bivšeg poslodavca ostvario isplatu tih primitaka za određeno razdoblje i u kojem iznosu.</strong></p>
    <p>U slučaju da su navedeni primici već dijelom isplaćeni za isto razdoblje, neoporezivo se može isplatiti samo razlika do propisanog iznosa.</p>
    <p>Za sve ostale uvjete koji se odnose na isplatu naknade, molimo konzultirajte računovodstvene propise i stručnu literaturu.</p>
    <p><strong>Radnik nije obvezan podnijeti pisanu izjavu ukoliko poslodavac ima uvid u podatke putem sustava ePorezna koji se odnose na isplaćene neoporezive primitke koje radnik može ostvariti od više poslodavaca i isplatitelja plaće do određenoga godišnjeg iznosa u poreznom razdoblju.</strong></p>

    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o porezu na dohodak, Pravilnik o porezu na dohodak.</p>
  `,
  sides: [
    {
      signature: "Radnik:",
        inputs:[{ 
        type: "input", 
        required: true, 
        placeholder: "Ime i prezime",
        label: "Ime i prezime",
        inSignature: true,
      },
      { 
        type: "input", 
        required: true, 
        placeholder: "Ulica i kućni broj",
      },
      { 
        type: "input", 
        required: true, 
        placeholder: "Mjesto",
      },
      { 
        type: "input", 
        required: true, 
        placeholder: "OIB",
      },
      ],
      suffix: " (u daljnjem tekstu: Radnik),"
    }
    ],
      
    headline: "upućuje sljedeću",
    title: "IZJAVU",
  
    noArticleNumbers: true,

    articles: [
      {
        title: "",
        dummy: true, 
        mandatory: true,
        statements: [
        {
          type: "input",
          mandatory: true,
          editable: false,
          parts: [
            { type: "text", content: "kojom ja, gore navedeni, s danom davanja ove Izjave, izjavljujem Poslodavcu" },
            { type: "input",  required: true, placeholder: "Unesite naziv poslodavca" },
            { type: "text", content: "," },
            { type: "input",  required: true, placeholder: "Unesite adresu poslodavca" },
            { type: "text", content: ", OIB:" },
            { type: "input",  required: true, placeholder: "Unesite OIB poslodavca" },
            { type: "text", content: "sljedeće:" },
          ],
          value: "",
        },
      ]
    },
    {
      title: '',
      mandatory: false,
      dummy: true, 
      statements: [
          {
              type: 'choice',
              mandatory: true,
              choices: [
                  {
                      parts: [
                        { type: "text", content: "tijekom" },
                        { type: "input",  required: true, placeholder: "Unesite godinu." },
                        { type: "text", content: "godine, od bivšeg/bivših poslodavaca odnosno od drugog/drugih poslodavaca kod kojih sam trenutno zaposlen, nisam primio isplate novčane paušalne naknade za podmirivanje troškova prehrane, niti sam ostvario podmirenje troškova prehrane radnika." },
                      ]
                    },
                     {
                      parts: [
                        { type: "text", content: "tijekom" },
                        { type: "input",  required: true, placeholder: "Unesite godinu." },
                        { type: "text", content: "godine, od bivšeg/bivših poslodavaca odnosno od drugog/drugih poslodavaca primio sam isplate novčane paušalne naknade za podmirivanje troškova prehrane u ukupnom iznosu od" },
                        { type: "input",  required: true, placeholder: "Unesite iznos." },
                        { type: "text", content: "." },
                      ]
                  },
                  {
                      parts: [
                        { type: "text", content: "tijekom" },
                        { type: "input",  required: true, placeholder: "Unesite godinu." },
                        { type: "text", content: "godine, od bivšeg/bivših poslodavaca odnosno od drugog/drugih poslodavaca, ostvario sam podmirenje troškova prehrane radnika nastalih za vrijeme radnog odnosa u ukupnom iznosu od" },
                        { type: "input",  required: true, placeholder: "Unesite iznos." },
                        { type: "text", content: "." }
                        ]
}],
value: '',
}
]
},
{
  title: '',
  mandatory: true,
  dummy: true, 
  statements: [
      {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Osim prethodno navedenog, po osnovi isplate novčane paušalne naknade za podmirivanje troškova prehrane odnosno podmirenja troškova prehrane radnika, tijekom prethodno naznačene godine nisam ostvario nikakve druge primitke.',
          value: '',
      }],
},
      {
        mandatory: true,
        static: true,
        type: 2, // date and place
        statements: [
          {
            type: "input",
            mandatory: true,
            parts: [
              {
                type: "text",
                content: "U"
              },
              {
                type: "input",
                value: "",
                placeholder: "Upišite mjesto.",
                required: true,
              },
              {
                type: "text",
                content: ", dana"
              },
              {
                type: "date",
                value: new Date(),
                required: true
              },
              {
                type: "text",
                content: "godine."
              }
            ]
          },
        ]
      },
      {
        mandatory: true,
        static: true,
        type: 3,  // signatures   
        statements: [],
      },
      {
        static: true,
        mandatory: true,
        editable: true,
        type: 4, 
        statements: [
          {
            type: "text",
            mandatory: true,
            editable: true,
            content: "\r\nPoslodavac svojim potpisom potvrđuje primitak Izjave dana ________________ godine.\r\n\r\nZa Poslodavca: ________________________. "
            },
          ],
        },
    ],
    };


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/236_izjava_prehrana.ts